module.exports = __webpack_public_path__ + "static/media/grass-tile-2x.d05eb31f.png";